export default __webpack_public_path__ + "static/media/bp-logo.1127cd49.svg";